import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-pagination-results',
        standalone: true,
templateUrl: './pagination-results.component.html',
    styleUrls: ['./pagination-results.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationResultsComponent {
@Input() paginationData:any
}
